import BaseCard from "./BaseCard";
import type React from "react";

export default function FormCard({
  children,
  subTitle,
  title,
}: {
  children: React.ReactNode;
  title: string;
  subTitle: string;
}) {
  return (
    <BaseCard props={{ className: "flex flex-col w-full" }}>
      <div className="flex flex-col gap-3">
        <span className="text-20-semi-bold">{title}</span>
        <span className="text-16-regular text-grayscale-500">{subTitle}</span>
      </div>
      <div className="mt-8 border-t border-grayscale-200">
        <div className="pt-6">{children}</div>
      </div>
    </BaseCard>
  );
}
